import React from 'react'
import styled from 'styled-components'

import { Book } from '../../../../data/book/data-types'
import { up } from 'styled-breakpoints'

type AffiliateBlockProps = {
  book: Book
}

const AffiliateBlock: React.FunctionComponent<AffiliateBlockProps> = ({ book }) => {
  const links = book.affiliate_links || []

  console.log({ links })

  return (
    <Container>
      <Title>Buy on</Title>
      <Links count={links.length}>
          {
              links.map(affiliate => (
                <Store href={affiliate.url} target='blank'>
                    <Icon src={affiliate.logo} />
                </Store>
              ))
          }
      </Links>
    </Container>
  )
}


const Container = styled.div`
  display: grid;

  grid-gap: 10px;

  color: ${p => p.theme.colors.bg};
`

const Title = styled.div`
    text-align: center;
`

const Links = styled.div<{ count: number }>`
  display: grid;
  grid-template-columns: repeat(${p => Math.min(p.count, 3)}, 1fr);
  grid-gap: 16px;

  ${up('desktop')} {
    grid-template-columns: 1fr;
  }
`

const Store = styled.a``

const Icon = styled.img`
    width: 100px;

    border-radius: 10px;
`

export default AffiliateBlock